import { render, staticRenderFns } from "./change-workspace-dialog.vue?vue&type=template&id=0aaf40ce&scoped=true&"
import script from "./change-workspace-dialog.vue?vue&type=script&lang=ts&"
export * from "./change-workspace-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./change-workspace-dialog.vue?vue&type=style&index=0&id=0aaf40ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf40ce",
  null
  
)

export default component.exports